import React from 'react';
import { useSelector, useDispatch } from 'store';
import { useNavigate } from 'react-router-dom';
import { setDisclaimer } from 'slices/disclaimerSlice';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog, { DialogProps } from 'components/Dialog';
import { Link } from 'react-router-dom';
// import ExternalLink from 'components/ExternalLink';

interface Props extends Omit<DialogProps, 'open' | 'title'> {}

const DialogDisclaimer = ({ ...props }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const disclaimerOpen = useSelector((state) => state.disclaimer);

  const handleAgree = () => {
    dispatch(setDisclaimer(false));
    localStorage.setItem(
      'servertools-disclaimer',
      String(new Date().getTime())
    );
  };

  const handleDisagree = () => {
    dispatch(setDisclaimer(false));
    localStorage.setItem('servertools-disclaimer', '0');
    navigate('/');
  };

  return (
    <Dialog
      center
      title="Notices & Disclaimers"
      open={disclaimerOpen}
      footer={(handleClose) => (
        <Box
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              columnGap: 2,
            }}
          >
            <Button variant="outlined" onClick={handleDisagree}>
              Disagree
            </Button>

            <Button variant="contained" onClick={handleAgree}>
              Agree
            </Button>
          </Box>
        </Box>
      )}
      {...props}
    >
      <Box
        sx={{
          p: 2,
          px: 3,
          display: 'flex',
          overflowY: 'auto',
          flexDirection: 'column',
          boxShadow: (theme) => `inset 0 0 8px 1px ${theme.palette.divider}`,
          '& p': {
            mb: 2,
          },
        }}
      >
        <Typography variant="subtitle2" fontWeight={500} mb={1}>
          THIS APPLICATION IS PROVIDED “AS IS” WITH NO WARRANTIES WHATSOEVER,
          INCLUDING ANY WARRANTY OF MERCHANTABILITY, FITNESS FOR ANY PARTICULAR
          PURPOSE, OR ANY WARRANTY OTHERWISE ARISING OUT OF ANY PROPOSAL,
          SPECIFICATION OR SAMPLE.
        </Typography>

        <Typography variant="body2">
          By using this MiTAC service, you understand and agree MiTAC may use
          and retain any information you provide for MiTAC's provision of this
          MiTAC service and other support and product improvement purposes. For
          more information, see the{' '}
          <Link
            to="https://www.mitacmct.com/EN/legal/privacy_policy/#"
            target="_blank"
          >
            Privacy Policy
          </Link>
          .
        </Typography>

        <Typography variant="body2">
          Information in this application is provided in connection with MiTAC
          products. No license, express or implied, by estoppel or otherwise, to
          any intellectual property rights is granted by this document. Except
          as provided in MiTAC's Terms and Conditions of Sale for such products,
          MiTAC assumes no liability whatsoever, and MiTAC disclaims any express
          or implied warranty, relating to sale and/or use of MiTAC products,
          including liability or warranties relating to fitness for a particular
          purpose, merchantability, or infringement of any patent, copyright, or
          other intellectual property right.
        </Typography>

        <Typography variant="body2">
          MiTAC products are not intended for use in medical, life-saving, or
          life-sustaining applications. MiTAC retains the right to make changes
          to this application at any time, without notice. This application
          should be used for reference only and the contained data is dependent
          on specific hardware.
        </Typography>

        {/* <Typography variant="body2">
          By using this Intel® service, you understand and agree Intel® may use
          and retain any information you provide for Intel®'s provision of this
          Intel® service and other support and product improvement purposes. For
          more information, see{' '}
          <ExternalLink
            to="https://www.intel.com/privacy"
            title="Intel® Privacy"
          >
            intel.com/privacy
          </ExternalLink>
          .
        </Typography>

        <Typography variant="body2">
          Information in this application is provided in connection with Intel®
          products. No license, express or implied, by estoppel or otherwise, to
          any intellectual property rights is granted by this document. Except
          as provided in Intel's Terms and Conditions of Sale for such products,
          Intel® assumes no liability whatsoever, and Intel® disclaims any
          express or implied warranty, relating to sale and/or use of Intel®
          products, including liability or warranties relating to fitness for a
          particular purpose, merchantability, or infringement of any patent,
          copyright, or other intellectual property right. Intel® products are
          not intended for use in medical, life saving, or life sustaining
          applications.{' '}
        </Typography>

        <Typography variant="body2">
          Intel® retains the right to make changes to this application at any
          time, without notice. This application should be used for reference
          only and the contained data is dependent on specific hardware.
        </Typography>

        <Typography variant="body2">
          The hardware vendor remains solely responsible for the design, sale,
          and functionality of its product, including any liability arising from
          product infringement or product warranty.
        </Typography> */}

        {/* <br /> */}

        <Typography variant="body2" textAlign="center" fontWeight={500}>
          Copyright © 2016-2023 MiTAC Computing Technology Corporation.
        </Typography>

        <Typography variant="body2" textAlign="center">
          MiTAC, the MiTAC logo, and other MiTAC marks are trademarks of MiTAC
          Corporation or its subsidiaries. Other names and brands may be claimed
          as the property of others.
        </Typography>
      </Box>
    </Dialog>
  );
};

export default DialogDisclaimer;
